import { jsx, Fragment } from "react/jsx-runtime";
import { PriceGroup } from "./components/PriceGroup/index.js";
const OfferDetails = ({
  productTileMaxLineNumber,
  enablePromoBreakdown
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    PriceGroup,
    {
      productTileMaxLineNumber,
      enablePromoBreakdown
    }
  ) });
};
export {
  OfferDetails
};
